// Pending-variants store for the nightly optimizer's human approval
// queue. Real backend reads from prompts/_proposed/*.yaml; the cockpit
// preview persists a local approval queue in sessionStorage so the
// flow demos end-to-end without a running cron.

import type { PromptVariant, TargetPrompt, OptimizerResult } from "./types";

import { env } from "../env";
const KEY = env.VITE_LS_OPTIMIZER_PENDING;

export interface PendingVariant {
  variant: PromptVariant;
  baseline_score: number;
  target: TargetPrompt;
  staged_path: string;
  staged_at: string;
}

function loadAll(): PendingVariant[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as PendingVariant[];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}
function saveAll(p: PendingVariant[]): void {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch { /* ignore */ }
}

export function listPending(): readonly PendingVariant[] {
  return loadAll();
}

export function stageWinner(result: OptimizerResult): PendingVariant | null {
  if (!result.winner) return null;
  const pv: PendingVariant = {
    variant: result.winner,
    baseline_score: result.baseline_score,
    target: result.seed.target_prompt,
    staged_path: result.staged_path ?? `prompts/_proposed/${result.seed.target_prompt}__${new Date().toISOString().slice(0, 10)}__${result.winner.backend}.yaml`,
    staged_at: new Date().toISOString(),
  };
  const all = loadAll();
  all.push(pv);
  saveAll(all);
  return pv;
}

export function approve(variant_id: string): void {
  saveAll(loadAll().filter((p) => p.variant.variant_id !== variant_id));
  // Real backend: PATCH /api/optimizer/{variant_id}/approve → promotes
  // staged YAML to live prompt path, archives current under
  // prompts/_archive/<live>__<ts>.yaml.
}
export function reject(variant_id: string): void {
  saveAll(loadAll().filter((p) => p.variant.variant_id !== variant_id));
}
